import CONSTANT from "../constant/constant";
import { leaveHolidayConstants } from "../constant/leaveHoliday.constants";

export const initialState = {
    listHoliday: {},
    errorCode: "",
    successCode: "",
    isLoading: false,
    searching: false,
    adding: false,
    deleting: false,
    updating: false,
};
const leaveHolidayReducer = (state = initialState, action) => {
    switch (action.type) {
        case leaveHolidayConstants.GET_HOLIDAY_LIST:
            return {
                ...state,
                searching: true,
            };
        case leaveHolidayConstants.GET_HOLIDAY_LIST_PAGE:
            return {
                ...state,
                isLoading: true,
            };
        case leaveHolidayConstants.GET_HOLIDAY_LIST_SUCCESS:
            return {
                ...state,
                listHoliday: action.list,
                isLoading: false,
                searching: false,
            };
        case leaveHolidayConstants.CREATE_HOLIDAY:
            return {
                ...state,
                adding: true,
            };
        case leaveHolidayConstants.CREATE_HOLIDAY_SUCCESS:
            return {
                ...state,
                adding: false,
                successCode: CONSTANT.messageCode.success,
                listHoliday: action.newList,
            };
        case leaveHolidayConstants.CREATE_HOLIDAY_FAIL:
            return {
                ...state,
                adding: false,
                errorCode: action.error,
            };
        case leaveHolidayConstants.DELETE_HOLIDAY:
            return {
                ...state,
                deleting: true,
            };
        case leaveHolidayConstants.DELETE_HOLIDAY_SUCCESS:
            return {
                ...state,
                deleting: false,
                successCode: CONSTANT.messageCode.success,
                listHoliday: action.newList,
            };
        case leaveHolidayConstants.DELETE_HOLIDAY_FAIL:
            return {
                ...state,
                deleting: false,
                errorCode: action.error,
            };
        case leaveHolidayConstants.UPDATE_HOLIDAY:
            return {
                ...state,
                updating: true,
            };
        case leaveHolidayConstants.UPDATE_HOLIDAY_SUCCESS:
            return {
                ...state,
                updating: false,
                successCode: CONSTANT.messageCode.success,
                listHoliday: action.newList,
            };
        case leaveHolidayConstants.UPDATE_HOLIDAY_FAIL:
            return {
                ...state,
                updating: false,
                errorCode: action.error,
            };
        case leaveHolidayConstants.CLEAR_MESSAGE:
            return {
                ...state,
                errorCode: "",
                successCode: "",
            };
        default:
            return state;
    }
};

export default leaveHolidayReducer;
